/*eslint-disable */
import Filters from './Filters';

export default Filters;
